<template>
  <div class="textarea-wrap">
    <cube-textarea
      v-model="value"
      :placeholder="placeholder"
      :indicator="false"
      :maxlength="100000000000"
      @input="handleInput"
      @blur="onBlur"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="value"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: '请输入'
    }
  },
  data () {
    return {
      value: ''
    }
  },
  mounted () {
    this.value = this.data.fieldvalue || ''
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    handleInput (val) {
      this.value = val.trim()
      this.$emit('change', this.value)
    },
    onBlur () {
      this.$refs.formItem.validate((res) => {
        // console.log(res)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cube-textarea-wrapper, .cube-input-append, .cube-input_active ::v-deep {
  height: 80px;
  &:after{
    border: 1px solid #ebebeb;
  }
}
::v-deep .cube-validator-msg {
  padding: 10px 4px;
}
</style>
